import { Checkbox, createTableColumn, TableCellLayout } from '@fluentui/react-components'
import { ApplicationAccessItem } from './AppAccessesPanel'
import { ApplicationAccessRole } from './AppAccessesPanel'

export function getAccessTableColumns({
  rolesArray,
  newCheckedMap,
  setCheckedMap,
}: {
  rolesArray: ApplicationAccessRole[]
  newCheckedMap: Map<number, Map<number, boolean>>
  setCheckedMap: (checkedMap: Map<number, Map<number, boolean>>) => void
}) {
  const tableColumns = [
    createTableColumn<ApplicationAccessItem>({
      columnId: 'name',
      compare: (a, b) => {
        return a.nodeId.localeCompare(b.nodeId)
      },
      renderHeaderCell: () => {
        return 'Node Id'
      },
      renderCell: (item) => {
        return (
          <TableCellLayout>
            <div
              style={{
                flexDirection: 'column',
                display: 'flex',
                paddingTop: '.5rem',
                paddingBottom: '.5rem',
                gap: '5px',
                lineHeight: '1rem',
              }}
            >
              <span style={{ fontSize: '16px' }}>{item.nodeId}</span>
              <span style={{ color: '#979797', fontSize: 'small' }}>{item.nodeDescription}</span>
            </div>
          </TableCellLayout>
        )
      },
    }),
    createTableColumn<ApplicationAccessItem>({
      columnId: 'nodeType',
      compare: (a, b) => {
        return a.nodeType.localeCompare(b.nodeType)
      },
      renderHeaderCell: () => {
        return 'Type'
      },
      renderCell: (item) => {
        return item.nodeType
      },
    }),
  ]

  const dynamicColumns = rolesArray.map((r) =>
    createTableColumn<ApplicationAccessItem>({
      columnId: r.roleId.toString(),
      // compare: (a, b) => {
      //   return a.nodeType.localeCompare(b.nodeType);
      // },
      renderHeaderCell: () => {
        return (
          <div
            style={{
              flexDirection: 'column',
              display: 'flex',
              paddingTop: '.5rem',
              paddingBottom: '.5rem',
              gap: '5px',
              lineHeight: '1rem',
            }}
          >
            <span>{r.roleName}</span>
            <span
              style={{
                color: '#979797',
                fontSize: 'small',
                fontWeight: '400',
              }}
            >
              {r.roleDescription}
            </span>
          </div>
        )
      },
      renderCell: (item) => {
        return (
          <Checkbox
            checked={newCheckedMap.has(r.roleId) && newCheckedMap.get(r.roleId)?.get(item.accessId)}
            onChange={(e, d) => {
              const newChecked = new Map<number, Map<number, boolean>>(newCheckedMap)
              newChecked.get(r.roleId!)?.set(item.accessId, d.checked as boolean)
              setCheckedMap(newChecked)
            }}
          />
        )
      },
    })
  )

  return [...tableColumns, ...dynamicColumns]
}
